import XcPanelRow from "@electricMotorShop/Widgets/Basic//XcPanelRow";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { ButtonIcon } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React from "react";
import { css } from "styled-components";

export interface XcPanelHeaderProps {
    headerColor?: string;
    layer: number;
    panelTitle: string;
    closeOverlay?: () => void;
    moveNextRight?: () => void;
}

export interface XcPanelHeaderStyles {
    panelTitleWrapper?: InjectableCss;
    titleButtonWrapper?: InjectableCss;
    titleButtonWithBackWrapper?: InjectableCss;
    panelTitle?: TypographyPresentationProps;
    panelBackClickable?: ClickablePresentationProps;
    panelBackIcon?: IconPresentationProps;
    panelCloseClickable?: ClickablePresentationProps;
    panelCloseIcon?: IconPresentationProps;
}

const xcPanelHeaderStyles: XcPanelHeaderStyles = {
    panelTitleWrapper: {
        css: css`
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            background: ${getColor("primary.main")};
            color: ${getColor("primary.contrast")};
            min-height: 60px;
        `,
    },
    titleButtonWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            flex: 1;
            margin-left: 20px;
        `,
    },
    titleButtonWithBackWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
        `,
    },
    panelTitle: {
        css: css`
            font-size: 18px;
            font-weight: 600;
            display: inline-block;
            color: ${getColor("primary.contrast")};
        `,
    },
    panelBackClickable: {
        css: css`
            background: ${getColor("primary.main")};
            padding: 10px 6px 10px;
        `,
    },
    panelBackIcon: {
        color: "white",
    },
    panelCloseClickable: {
        css: css`
            padding: 10px;
            margin-left: auto;
        `,
    },
    panelCloseIcon: {
        color: "white",
    },
};

const styles = xcPanelHeaderStyles;

const XcPanelHeader = (props: XcPanelHeaderProps) => {
    const { headerColor, layer, panelTitle, closeOverlay, moveNextRight } = props;

    const backArrowClickHandler = () => {
        if (moveNextRight) {
            moveNextRight();
        }
    };

    return (
        <XcPanelRow as="div" color={headerColor} header>
            <StyledWrapper {...styles.panelTitleWrapper} data-test-selector="PanelTitleWrapper">
                {panelTitle === "All Categories" || panelTitle === "Menu" ? (
                    <StyledWrapper {...styles.titleButtonWrapper}>
                        <Typography {...styles.panelTitle}>{panelTitle}</Typography>
                    </StyledWrapper>
                ) : (
                    <>
                        <Clickable
                            color={headerColor}
                            onClick={backArrowClickHandler}
                            tabIndex={layer === 0 ? 0 : -1}
                            {...styles.panelBackClickable}
                        >
                            <ButtonIcon src="ChevronLeft" {...styles.panelBackIcon} />
                            <VisuallyHidden>{translate("Back")}</VisuallyHidden>
                        </Clickable>
                        <StyledWrapper {...styles.titleButtonWithBackWrapper}>
                            <Typography {...styles.panelTitle}>{panelTitle}</Typography>
                        </StyledWrapper>
                    </>
                )}

                {closeOverlay && (
                    <Clickable
                        color={headerColor}
                        onClick={closeOverlay}
                        tabIndex={layer === 0 ? 0 : -1}
                        {...styles.panelCloseClickable}
                    >
                        <ButtonIcon src="X" {...styles.panelCloseIcon} />
                        <VisuallyHidden>{translate("Close")}</VisuallyHidden>
                    </Clickable>
                )}
            </StyledWrapper>
        </XcPanelRow>
    );
};

export default XcPanelHeader;
